// Normalize message for comparison (treat null, undefined, and empty string as equivalent)
const normalizeMessage = (message) => {
  if (!message || (typeof message === 'string' && message.trim() === '')) {
    return '';
  }
  if (typeof message === 'string') {
    return message.trim();
  }
  return String(message).trim();
};

const messagesAreSame = (firstMessage, secondMessage) => (
  normalizeMessage(firstMessage) === normalizeMessage(secondMessage)
);

export const mergeItems = ({ items = [], item }) => {
  if (items.length === 0) {
    return [item];
  }

  const sameItemIndex = items.findIndex(
    (i) => i.id === item.id &&
      i.selection.size === item.selection.size &&
      modifiersAreSame(i.selection.modifiers, item.selection.modifiers) &&
      messagesAreSame(i.selection.message, item.selection.message),
  );

  if (sameItemIndex === -1) {
    return [...items, item];
  }

  const mergedItem = items[sameItemIndex];

  return [
    ...items.filter((_, index) => index !== sameItemIndex),
    {
      ...mergedItem,
      selection: {
        ...mergedItem.selection,
        message: item.selection.message || mergedItem.selection.message,
        qty: mergedItem.selection.qty + item.selection.qty,
      },
    },
  ];
};

export function sortItems(items) {
  return items.sort((a, b) => a.id - b.id);
}

function modifiersAreSame(firstModifiers, secondModifiers) {
  const firstModifiersValue = Object.values(firstModifiers);
  const secondModifiersValue = Object.values(secondModifiers);
  if (firstModifiersValue.length !== secondModifiersValue.length) {
    return false;
  }
  return firstModifiersValue.every((fm) => secondModifiersValue.some(
    (sm) => sm.id === fm.id && sm.qty === fm.qty,
  ));
}
